<template>
  <div
    class="cover-image-wrap"
    :class="{ 'not-mac': !isApple, 'mac' : isApple }"
  >
    <div>
      <div
        :class="{'cover-image':!pageOpen, 'reverse-cover-image':pageOpen}"
      >
        <svg
          class="cover-image-svg"
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 3300 2089"
          xml:space="preserve"
        >
          <g ref="group1" class="group-1">
            <path
              class="black from-left"
              d="M2721.56,1362.188c4.477-13.122,8.805-25.776,12.501-38.6H2690v38.6H2721.56z"
            ></path>
            <rect
              x="1566.702"
              y="1087.588"
              class="blue from-right"
              width="270.88"
              height="236"
            ></rect>
            <path
              class="blue from-left"
              d="M1837.581,1362.188v192.2h194.818h578.008c47.708-56.398,85.625-121.341,111.153-192.2H1837.581z"
            ></path>
            <rect
              x="1837.581"
              y="721.888"
              class="black from-top"
              width="168.319"
              height="601.7"
            ></rect>
            <rect
              x="2005.9"
              y="1211.788"
              class="red from-right"
              width="584.072"
              height="111.8"
            ></rect>
            <rect
              x="1615.3"
              y="1323.587"
              class="black from-left"
              width="222.281"
              height="38.6"
            ></rect>
          </g>
          <g ref="group2" class="group-2">
            <path
              class="pink from-right"
              d="M1837.581,721.888H2005.9v489.9h584.072v111.8H2690v-282.875h59.076
		c-33.598-191.824-154.373-353.649-319.986-445.147h-591.509V721.888z"
            ></path>
            <path
              class="red from-top"
              d="M1807.6,612.574c-45.21,27.32-86.69,60.188-123.5,97.66v377.354h123.5V612.574z"
            ></path>
            <path
              class="pink from-left"
              d="M2032.399,1554.387h-194.818v149.223c87.519,46.649,187.605,73.089,293.869,73.089
		c162.535,0,310.624-61.841,422.029-163.274h-521.081V1554.387z"
            ></path>
            <path
              class="pink from-top"
              d="M1638.4,1087.588v-325.43c-27.816,35.346-51.91,73.757-71.698,114.641v210.788H1638.4z"
            ></path>
            <path
              class="pink from-left"
              d="M1735.409,1477.688h0.091v-115.5h-194.16c8.077,22.419,17.388,44.249,27.864,65.4h166.204V1477.688z"
            ></path>
            <path
              class="pink from-top"
              d="M1566.702,1197.887h-47.253V1012.46c-9.853,44.151-15.062,90.055-15.062,137.176
		c0,60.356,8.537,118.717,24.452,173.951h37.862V1197.887z"
            ></path>
            <path
              class="red from-left"
              d="M1735.409,1477.688v-50.1h-166.204c8.5,17.161,17.768,33.873,27.749,50.1H1735.409z"
            ></path>
            <path
              class="pink from-bottom"
              d="M1596.953,1477.688c37.044,60.227,83.979,113.714,138.547,158.202v-158.202h-0.091H1596.953z"
            ></path>
          </g>
          <g ref="group3" class="group-3">
            <path
              class="red from-right"
              d="M1837.581,499.805v95.761c87.657-46.589,187.678-72.992,293.869-72.992
		c107.716,0,209.085,27.166,297.64,72.992H2690v-95.761H1837.581z"
            ></path>
            <path
              class="black from-top"
              d="M1837.581,595.565v-95.761V203.627H1807.6v408.947C1817.421,606.639,1827.418,600.967,1837.581,595.565z"
            ></path>
            <path
              class="blue from-right"
              d="M2734.061,1323.587h120.04v-282.875h-105.024c6.196,35.377,9.437,71.772,9.437,108.924
		C2758.513,1209.993,2749.976,1268.353,2734.061,1323.587z"
            ></path>
            <path
              class="red from-bottom"
              d="M1735.5,2043.688h102.081V1703.61c-36.409-19.27-70.52-41.99-102.081-67.721V2043.688z"
            ></path>
            <path
              class="black from-right"
              d="M3299.9,1554.387h-689.493c-17.677,20.897-36.698,40.619-56.928,59.038h746.42V1554.387z"
            ></path>
            <path
              class="blue from-top"
              d="M1807.6,612.574V375.188h-123.5v335.046C1720.91,672.762,1762.39,639.894,1807.6,612.574z"
            ></path>
            <path
              class="blue from-left"
              d="M1596.953,1477.688H724.1v456.3h1011.4v-298.098C1680.933,1591.402,1633.997,1537.915,1596.953,1477.688z"
            ></path>
            <path
              class="red from-right"
              d="M2610.407,1554.387H2854.1v-192.2h-132.54C2696.033,1433.047,2658.116,1497.989,2610.407,1554.387z"
            ></path>
            <path
              class="black from-top"
              d="M1684.1,55.667h-45.7v706.491c14.279-18.144,29.541-35.476,45.7-51.925V55.667z"
            ></path>
            <path
              class="black from-left"
              d="M1596.953,1477.688c-9.981-16.227-19.249-32.939-27.749-50.1H1278.1v50.1H1596.953z"
            ></path>
            <path
              class="black from-left"
              d="M1409.6,1323.587v38.6h131.74c-4.569-12.682-8.741-25.553-12.501-38.6H1409.6z"
            ></path>
            <path
              class="black from-top"
              d="M1566.702,747.779h-47.253v264.681c10.595-47.475,26.566-92.92,47.253-135.661V747.779z"
            ></path>
          </g>
          <g ref="group4" class="group-4">
            <polygon
              class="blue from-right"
              points="2156.025,499.805 2156.025,453.688 2156.025,341.788 1837.581,341.788 1837.581,499.805 	"
            ></polygon>
            <rect
              x="2156.025"
              y="453.688"
              class="black from-right"
              width="763.275"
              height="46.117"
            ></rect>
            <rect
              x="663.788"
              y="1477.688"
              class="black from-bottom"
              width="60.312"
              height="607"
            ></rect>
            <rect
              x="460.267"
              y="1331.381"
              class="red from-left"
              width="817.833"
              height="146.307"
            ></rect>
            <rect
              x="9.593"
              y="1290.82"
              class="black from-left"
              width="1082.771"
              height="40.561"
            ></rect>
            <rect
              x="2854.1"
              y="1473.488"
              class="blue from-right"
              width="387.9"
              height="80.9"
            ></rect>
            <rect
              x="2854.1"
              y="1149.636"
              class="black from-bottom"
              width="61.5"
              height="323.654"
            ></rect>
            <rect
              x="885.4"
              y="1933.988"
              class="black from-left"
              width="700.6"
              height="41.672"
            ></rect>
          </g>
          <g ref="balls" class="balls">
            <circle
              class="black appear"
              cx="2089"
              cy="63.28"
              r="61.317"
            ></circle>
            <ellipse
              class="pink appear"
              cx="1060.499"
              cy="1006.637"
              rx="194.851"
              ry="194.851"
            ></ellipse>
            <circle
              class="black appear"
              cx="1328.95"
              cy="1204.288"
              r="108.4"
            ></circle>
            <ellipse
              class="black appear"
              cx="2313.951"
              cy="258.188"
              rx="120.4"
              ry="120.4"
            ></ellipse>
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>
<script>
let delay = {
  interval: 0.05,
  start: 0
};
let reverseDelay = {
  interval: 0.0075,
  start: 28
};
import { eventBus } from "../main";
export default {
  data() {
    return {
      childCount: 0,
      delay: delay,
      invertColors: true
    };
  },
  props: ["pageOpen", "isApple"],
  methods: {
    openWorkPage() {
      eventBus.$emit("goToWorkFromSVG");
    }
  },
  mounted() {
    Object.entries(this.$refs).forEach(([key, value]) => {
      for (let path of value.children) {
        this.childCount++;
        path.addEventListener("click", this.openWorkPage);
      }
    });
    if (this.pageOpen) {
      this.delay = reverseDelay;
      this.delay.start = this.childCount;
    } else {
      this.delay = delay;
    }
    let currentDelay = this.delay.interval * this.delay.start;
    Object.entries(this.$refs).forEach(([key, value]) => {
      for (let path of value.children) {
        path.style.animationDelay = `${currentDelay}s`;
        if (!this.pageOpen) {
          currentDelay += this.delay.interval;
        } else {
          currentDelay -= this.delay.interval;
        }
      }
    });
  }
};
</script>
